define('personalization/edap-personalization-integration',['edap', 'personalization/register-personalization-listeners'], function(edap, listeners) {
    'use strict';

    var moduleName = 'personalization',
        myEdap = new edap.Scope(moduleName);

    /**
     *  Main init() for the personalization integration. It kicks off registering all the listeners.
     *
     *  @returns {Object} - EDAP instance to make this chainable
     */
    function init() {
        listeners.setupListeners(myEdap);

        return edap;
    }

    return {
        init: init
    };
});

